"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyGetListApi = companyGetListApi;
exports.exportOrderApi = exportOrderApi;
exports.getOrderInfo = getOrderInfo;
exports.getOrderList = getOrderList;
exports.getOrderLog = getOrderLog;
exports.getOrderStatistics = getOrderStatistics;
exports.getOrderStatusNum = getOrderStatusNum;
exports.orderMarkApi = orderMarkApi;
exports.orderSendApi = orderSendApi;
exports.sheetInfoApi = sheetInfoApi;
exports.updateTrackingNumberApi = updateTrackingNumberApi;
exports.videoSendApi = videoSendApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 供应商订单列表
 */
function getOrderList(params) {
  return (0, _request.default)({
    url: '/supplier/order/list',
    method: 'GET',
    params: params
  });
}

/**
 * 供应商订单详情
 */
function getOrderInfo(orderNo) {
  return (0, _request.default)({
    url: '/supplier/order/info',
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 订单各状态数量
 */
function getOrderStatusNum(params) {
  return (0, _request.default)({
    url: '/supplier/order/status/num',
    method: 'GET',
    params: params
  });
}

/**
 * 订单统计（金额汇总）
 */
function getOrderStatistics(data) {
  return (0, _request.default)({
    url: '/supplier/order/statistics',
    method: 'POST',
    data: data
  });
}

/**
 * 订单操作记录
 */
function getOrderLog(params) {
  return (0, _request.default)({
    url: '/supplier/order/status/list',
    method: 'GET',
    params: params
  });
}

/**
 * 订单备注
 */
function orderMarkApi(params) {
  return (0, _request.default)({
    url: '/supplier/order/mark',
    method: 'POST',
    params: params
  });
}

/**
 * 订单发货
 */
function orderSendApi(data) {
  return (0, _request.default)({
    url: '/supplier/order/send',
    method: 'POST',
    data: data
  });
}

/**
 * 修改订单运单号
 */
function updateTrackingNumberApi(data) {
  return (0, _request.default)({
    url: '/supplier/order/update/tracking/number',
    method: 'POST',
    data: data
  });
}

/**
 * 面单默认配置信息
 */
function sheetInfoApi() {
  return (0, _request.default)({
    url: '/supplier/order/sheet/info',
    method: 'GET'
  });
}

/**
 * 视频号物流公司
 */
function companyGetListApi() {
  return (0, _request.default)({
    url: '/supplier/order/video/company/list',
    method: 'GET'
  });
}

/**
 * 视频号发货
 */
function videoSendApi(data) {
  return (0, _request.default)({
    url: '/supplier/order/video/send',
    method: 'POST',
    data: data
  });
}

/**
 * 导出订单
 */
function exportOrderApi(params) {
  return (0, _request.default)({
    url: '/supplier/order/export',
    method: 'GET',
    params: params
  });
}